import { BUILTIN_SETTINGS, type ScreensaverStyle } from '../../../server/lib/eventSettings'
import HypeOverlay from '../HypeOverlay'
import ShutterSaver from './ShutterSaver'
import FlashSaver from './FlashSaver'
import KidsSaver from './KidsSaver'
import BusinessSaver from './BusinessSaver'
import PartySaver from './PartySaver'
import type { SaverProps } from './shared'

export const DEFAULT_VIDEO = '/video/bg_video.mp4'

/** Styles that draw the configured video somewhere in the scene. */
export const STYLE_USES_VIDEO: Record<ScreensaverStyle, boolean> = {
  classic: true, shutter: true, flash: true, kids: false, business: true, party: true,
}

interface ScreensaverProps {
  style?: ScreensaverStyle
  videoSrc?: string
  phrases?: string[]
  intervalSeconds?: number
  maxMessages?: number
  wakeMethod?: 'touch' | 'motion'
}

export default function Screensaver({ style = 'classic', videoSrc, phrases, intervalSeconds, maxMessages, wakeMethod }: ScreensaverProps) {
  const props: SaverProps = {
    videoSrc: videoSrc || DEFAULT_VIDEO,
    phrases: phrases ?? BUILTIN_SETTINGS.screensaver.phrases,
    intervalSeconds: intervalSeconds || 2.5,
    maxMessages: maxMessages || 4,
    wakeMethod: wakeMethod || 'touch',
  }
  switch (style) {
    case 'shutter': return <ShutterSaver {...props} />
    case 'flash': return <FlashSaver {...props} />
    case 'kids': return <KidsSaver {...props} />
    case 'business': return <BusinessSaver {...props} />
    case 'party': return <PartySaver {...props} />
    default:
      return (
        <>
          <video src={props.videoSrc} autoPlay loop muted playsInline className="h-full w-full object-cover" />
          <HypeOverlay active phrases={props.phrases} maxMessages={props.maxMessages} intervalSeconds={props.intervalSeconds} />
        </>
      )
  }
}
